// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2BWUD","footer":"ReportModalFilter_footer__3ThQ3"};